export default "__VITE_ASSET__BJmF3tQx__"